// extracted by mini-css-extract-plugin
export default {"selectMenu":"BSelectMenu-module_selectMenu_e83a79bb"};